import styled from 'styled-components';

interface NavHeaderProps {
  typeHeader: string;
}

export const Container = styled.header`
  width: 100%;
  background: transparent
    linear-gradient(
      92deg,
      ${({ theme }) => theme.colors.secondary} 0%,
      ${({ theme }) => theme.colors.primary} 100%
    );
`;

export const Content = styled.div<NavHeaderProps>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  max-height: 5rem;
  padding: 0 0.5rem;
  .logo {
    display: flex;
    max-width: 15rem;
    max-height: 3.8rem;
    align-self: center;
    object-fit: fill;
    background: none;
    border: none;
    align-items: center;
  }

  .logoMobile {
    display: none;
    padding: 0.5rem 0;
  }

  .containerLoggedOut {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .containerLoggedOutItens {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    .textRegister {
      display: flex;
      gap: 1rem;
      color: ${({ theme }) => theme.colors.yellow};
      font-weight: 300;
      font-size: 1.1rem;
    }
  }
  @media (max-width: 650px) {
    .containerLoggedOutItens {
      display: none;
    }
  }

  .container {
    height: 100%;
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .containerOptions {
      gap: 1rem;
      display: flex;
      justify-content: space-around;

      .nav-link {
        padding: 0.5rem 1rem;
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.background_white};
        background-color: transparent;
        transition: background-color 0.3s, color 0.3s;
        text-decoration: none;
      }

      .nav-link:hover {
        padding: 0.5rem 1rem;
        transition: background-color 0.3s, color 0.3s;
        border-radius: 8px;
        background-color: ${({ theme }) => theme.colors.tertiary};
        color: ${({ theme }) => theme.colors.secondary};
      }

      p,
      a {
        height: 100%;
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.background_white};
        font-size: 1.3rem;
        font-weight: 300;
        cursor: pointer;
        text-decoration: none;
        &:hover {
          color: ${({ theme }) => theme.colors.yellow_200};
        }
      }

      .active {
        padding: 0.5rem 1rem;
        transition: background-color 0.3s, color 0.3s;
        border-radius: 8px;
        background-color: ${({ theme }) => theme.colors.tertiary};
        color: ${({ theme }) => theme.colors.secondary};
      }

      .withSubOption:active {
        pointer-events: none;
      }

      .containerPath {
        display: flex;
        justify-content: center;
        padding: 0 1rem;
        position: absolute;
        top: 4.2rem;
        left: 0;
        width: 100%;
        background: ${({ theme }) => theme.colors.background_white};
        z-index: 999999;
        -webkit-box-shadow: 0px 16px 24px -20px rgba(0, 0, 0, 0.25);
        -moz-box-shadow: 0px 16px 24px -20px rgba(0, 0, 0, 0.25);
        box-shadow: 0px 16px 24px -20px rgba(0, 0, 0, 0.25);
        .contentPath {
          width: 50%;
          padding: 1rem 0;
          display: flex;
          flex-direction: column;

          .path {
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: flex-start;
            .links {
              display: flex;
              flex-direction: column;
            }
            .description {
              display: flex;

              p {
                cursor: default;
                font-size: 1.2rem;
                color: ${({ theme }) => theme.colors.text_gray};
              }
            }

            a {
              color: ${({ theme }) => theme.colors.secondary};
              font-size: 1.5rem;
              text-decoration: none;
              font-weight: 500;

              &:hover {
                color: ${({ theme }) => theme.colors.tertiary_500};
                text-decoration: underline;
              }
            }
          }
        }
      }
    }

    .containerProfile {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }

  .mobile {
    display: none;
  }

  ${(props) =>
    props.typeHeader === 'loggedOut'
      ? `
    @media(max-width: 650px){
      .logo {
        display: none;
        min-width: 16.5rem;
      }

      .logoMobile{
        display: block !important;
      }

      .containerLoggedOut{
        margin-left: 1rem;
      }

      .container{
        display: none;
      }

      .mobile {
        display: initial;
        font-size: 2rem;
        color: white;
      }
    }
  `
      : props.typeHeader !== 'loggedOut' && props.typeHeader !== 'default'
      ? `
    @media(max-width: 1000px){
      .logo {
        display: none;
        min-width: 16.5rem;
      }

      .logoMobile{
        display: block !important;
      }

      .containerLoggedOut{
        margin-left: 1rem;
      }

      .container{
        display: none;
      }

      .mobile {
        display: initial;
        font-size: 2rem;
        color: white;
      }
    }
  `
      : `
  `}
`;
